/* template */
<template><page><base-container><div :class='["divider-wrapper"]'><view-desc>分割线</view-desc><divider-normal/></div><div :class='["divider-wrapper"]'><view-desc>分割线 - 带文本内容</view-desc><divider-text/></div><div :class='["divider-wrapper"]'><view-desc>分割线 - position-left</view-desc><divider-position position="left"/></div><div :class='["divider-wrapper"]'><view-desc>分割线 - position-right</view-desc><divider-position position="right" text="文本内容"/></div><div :class='["divider-wrapper"]'><view-desc>分割线 - slot</view-desc><divider-slot/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_46320547"}'>
.divider-wrapper
  padding-top 20px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_46320547"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_46320547"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_46320547"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'divider-normal':getComponent(require("./divider-normal.mpx?isComponent&outputPath=components%2Fdivider-normald57fe118%2Findex")),'divider-text':getComponent(require("./divider-text.mpx?isComponent&outputPath=components%2Fdivider-text5a8a838c%2Findex")),'divider-slot':getComponent(require("./divider-slot.mpx?isComponent&outputPath=components%2Fdivider-slot646cdaea%2Findex")),'divider-position':getComponent(require("./divider-position.mpx?isComponent&outputPath=components%2Fdivider-position7df3a136%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>